<template>
  <div :class="['modal', { 'is-active': show }]">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          New Question for {{ page.attributes.title }}
        </p>
        <button class="delete" v-on:click="hide"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <ul>
              <li>
                <button
                  class="button is-link"
                  @click="addField('singletext', 0)"
                >
                  Single Text
                </button>
              </li>
              <li>
                <button
                  class="button is-link"
                  @click="addField('multitext', 0)"
                >
                  Multi Text
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('date', 0)">
                  Date
                </button>
              </li>
              <li>
                <button
                  class="button is-link"
                  @click="addField('multichoice', 0)"
                >
                  Multi Choice
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('checkbox', 0)">
                  Checkboxes
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('file', 10)">
                  File
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('stripe', 11)">
                  Stripe
                </button>
              </li>
              <li>
                <button
                  class="button is-link"
                  @click="addField('instruction', 13)"
                >
                  Instruction
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('video', 14)">
                  Video
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('async_case', 17)">
                  Async Case
                </button>
              </li>
            </ul>
          </div>
          <div class="column">
            <ul>
              <li>
                <button
                  class="button is-link"
                  @click="addField('multitext', 1)"
                >
                  Name
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('email', 2)">
                  Email
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('zip', 5)">
                  Zip Code
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('phone', 4)">
                  Phone
                </button>
              </li>
              <li>
                <button
                  class="button is-link"
                  @click="changeType('multichoice', 12)"
                >
                  Referral Reason
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('casegrid', 0)">
                  Case Grid
                </button>
              </li>
              <li>
                <button
                  class="button is-link"
                  @click="addField('ondemand', 15)"
                >
                  On-Demand
                </button>
              </li>
              <li>
                <button class="button is-link" @click="addField('dropdown', 0)">
                  Dropdown
                </button>
              </li>
              <li>
                <button
                  class="button is-link"
                  @click="addField('visuwell_user', 0)"
                >
                  Visuwell User
                </button>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-link" v-on:click="hide">Cancel</a>
      </footer>
    </div>
  </div>
</template>

<script>
import InterviewsService from "@/services/InterviewsService";

export default {
  name: "add-question",

  props: ["page"],

  computed: {
    show() {
      return this.$store.state.interview.showAddQuestion;
    }
  },

  methods: {
    hide() {
      this.$store.dispatch("interview/toggleAddQuestion", false);
    },

    addField(type, dataType) {
      InterviewsService.addQuestion(this.page.id, type, dataType).then(() => {
        this.hide();
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
